import React from 'react'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Modal } from 'components/shared/Modal/Modal'
import { CandidateForm } from './common/CandidateForm/CandidateForm'

import { useCandidateManagementModalState } from './hooks'

import styles from './CandidateManagementModal.module.scss'

export const CandidateManagementModal = ({
  candidate,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useCandidateManagementModalState(
    { candidate, isOpen },
    { onCancel, onClose, onConfirm },
  )

  const {
    form: { control, formState },
    languages,
    isConfirmationOpen,
  } = state
  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
  } = handlers

  return (
    <React.Fragment>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Save`}
        title={candidate ? t`Edit candidate` : t`Add candidate`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <CandidateForm {...{ control, formState, languages }} />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </React.Fragment>
  )
}
